import { createAction } from '@reduxjs/toolkit';

import wsSlice from './slice';
import prepareActions from '../prepareActions';

export const wsActions = {
  ...wsSlice.actions,
  sendMessageRequest: createAction(
    'ws/sendMessageRequest',
    ({ values, resolve }) => ({
      payload: values,
      meta: { resolve },
    }),
  ),
  sendImageRequest: createAction(
    'ws/sendImageRequest',
    prepareActions.movePromiseToMeta,
  ),
  handleResponse: createAction('REDUX_WEBSOCKET::MESSAGE', payload => ({
    payload,
  })),
  // INJECT
};
